<template>
  <row :gutter="16">
    <i-col span="8">
      <div class="ms-text">
        Общая сумма по Договору
      </div>
      <alert type="info">
        {{ getFormattedCosts(stats.contract_cost, false, withVat) }}
      </alert>
    </i-col>
    <i-col span="8">
      <div class="ms-text">
        Общая сумма платежей
      </div>
      <alert type="warning">
        {{ getFormattedCosts(stats.payments_value, false, withVat) }}
      </alert>
    </i-col>
    <i-col span="8">
      <div class="ms-text">
        Общий долг по Договору
      </div>
      <alert type="error">
        {{
          getFormattedCosts(
            stats.payment_lag > 0 ? stats.payment_lag : 0,
            false,
            withVat
          )
        }}
      </alert>
    </i-col>
  </row>
</template>

<script>
import { getFormattedCosts } from '@/utils'

export default {
  props: ['stats', 'contract-page'],
  computed: {
    withVat () {
      return this.$store.state.contracts.current.with_vat
    }
  },
  methods: {
    getFormattedCosts
  }
}
</script>

<style>
</style>
